<template>
  <v-text-field
    v-model="likePattern"
    clearable
    @keyup.enter="applyFiltersAndGetItems"
    label="Patrón LIKE para la categoría"
    prepend-icon="check"
  />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "classifier"
);

export default {
  computed: {
    ...mapState(["likePatternCategoryFilter"]),
    likePattern: {
      set(pattern) {
        this.setLikePatternCategoryFilter(pattern);
      },
      get() {
        return this.likePatternCategoryFilter;
      },
    },
  },
  methods: {
    ...mapMutations(["setLikePatternCategoryFilter"]),
    ...mapActions(["applyFiltersAndGetItems"]),
  },
};
</script>
